import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'app-generic-combobox',
  templateUrl: './generic-combobox.component.html',
  styleUrls: ['./generic-combobox.component.scss']
})
export class GenericComboboxComponent implements OnInit {
  @Input() options: string[] = []
  @Input() selected: string = ''
  @Input() txtLabel: string = ''

  @Output() optionSelected = new EventEmitter<string>()

  constructor( ) { }

  ngOnInit(): void { }

  emitSelected(event: MatSelectChange) {
    this.optionSelected.emit(event.value)
  }
}
